import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { auth } from './firebase';
import { getConfig } from '../config/environment';

const httpLink = new HttpLink({
  uri: getConfig().cloudRunServices.graphqlUrl,
});

const authLink = setContext(async (_, { headers }) => {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken(false) : null;
  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  };
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies: {
      Organization: {
        keyFields: ['organizationId'],
      },
      Contact: {
        // Without this, Apollo can't normalize Contact responses (default
        // keyFields is ['id'] but schema returns contactId) — causing
        // GET_CONTACT to re-fetch on observer re-evaluation.
        keyFields: ['contactId'],
      },
      FlowContactSummary: {
        keyFields: ['executionId'],
      },
      CallSummary: {
        // SPEC-1596: same call_id can exist as multiple Spanner Calls rows
        // (one per writer's conversation_id) with different outcome / summary
        // / transcript. Key by both so duplicates don't overwrite each other
        // in the cache and bleed across views (flow ↔ contact).
        keyFields: ['callId', 'conversationId'],
      },
    },
  }),
});
